import { toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lightswitch__input" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "lightswitch__toggle" }, null, -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["lightswitch", [
			{ 'lightswitch--disabled': $props.disabled },
			{ 'lightswitch--justify-end': $props.justify === 'end' }
		]])
  }, [
    _createTextVNode(_toDisplayString($props.checked ? $props.label : $props.offLabel ?? $props.label) + " ", 1 /* TEXT */),
    _createElementVNode("label", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($props.checked) = $event)),
        checked: $props.checked,
        type: "checkbox",
        onChange: _cache[1] || (_cache[1] = $event => (_ctx.$emit( 'change', $event.target.checked )))
      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2), [
        [_vModelCheckbox, $props.checked]
      ]),
      _hoisted_3
    ])
  ], 2 /* CLASS */))
}